/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Useralreadyhasbusinesserror4Inputs */

const en_useralreadyhasbusinesserror4 = /** @type {(inputs: Useralreadyhasbusinesserror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This account already owns a business.`)
};

const de_useralreadyhasbusinesserror4 = /** @type {(inputs: Useralreadyhasbusinesserror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Konto besitzt bereits ein Unternehmen.`)
};

/**
* | output |
* | --- |
* | "This account already owns a business." |
*
* @param {Useralreadyhasbusinesserror4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const useralreadyhasbusinesserror4 = /** @type {((inputs?: Useralreadyhasbusinesserror4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Useralreadyhasbusinesserror4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_useralreadyhasbusinesserror4(inputs)
	return de_useralreadyhasbusinesserror4(inputs)
});
export { useralreadyhasbusinesserror4 as "userAlreadyHasBusinessError" }